import api from './api';

export interface InactiveDiscussionStatus {
  total_active_discussions: number;
  inactive_discussions_count: number;
  inactive_discussions: InactiveDiscussion[];
}

export interface InactiveDiscussion {
  id: string;
  title: string;
  user: string;
  hours_inactive: number;
  last_user_message: string;
}

export interface AllDiscussion {
  id: string;
  title: string;
  user_email: string;
  status: 'active' | 'closed';
  created_at: string;
  updated_at: string;
  last_user_message_time: string;
  message_count: number;
}

export interface CloseInactiveResult {
  message: string;
  closed_count: number;
}

class DiscussionMaintenanceApiService {
  /**
   * Récupère le statut des discussions inactives
   */
  async getInactiveDiscussionsStatus(): Promise<InactiveDiscussionStatus> {
    try {
      const response = await api.get('/api/discussions/inactive-status/');
      return response.data;
    } catch (error: any) {
      if (error.response?.data?.error) {
        throw new Error(error.response.data.error);
      }
      throw new Error('Erreur lors de la récupération du statut des discussions inactives');
    }
  }

  /**
   * Ferme manuellement les discussions inactives (Admin uniquement)
   */
  async closeInactiveDiscussions(): Promise<CloseInactiveResult> {
    try {
      const response = await api.post('/api/discussions/close-inactive/');
      return response.data;
    } catch (error: any) {
      if (error.response?.data?.error) {
        throw new Error(error.response.data.error);
      }
      throw new Error('Erreur lors de la fermeture des discussions inactives');
    }
  }

  /**
   * Récupère TOUTES les discussions (actives et fermées)
   */
  async getAllDiscussions(): Promise<AllDiscussion[]> {
    try {
      const response = await api.get('/api/discussions/all/');
      return response.data;
    } catch (error: any) {
      if (error.response?.data?.error) {
        throw new Error(error.response.data.error);
      }
      throw new Error('Erreur lors de la récupération des discussions');
    }
  }

  /**
   * Formate la durée d'inactivité en texte lisible
   */
  formatInactivityDuration(hours: number): string {
    if (hours < 24) {
      return `${Math.round(hours)}h`;
    } else {
      const days = Math.floor(hours / 24);
      const remainingHours = Math.round(hours % 24);
      return `${days}j ${remainingHours}h`;
    }
  }

  /**
   * Vérifie si une discussion doit être fermée (>24h d'inactivité)
   */
  shouldBeClosed(hours: number): boolean {
    return hours >= 24;
  }
}

export const discussionMaintenanceApiService = new DiscussionMaintenanceApiService();
